import { Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ControlContainer, NgForm, NgModelGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { AtividadeService } from 'src/app/services/atividade/atividade.service';
import { Atividade } from "../../../core/atividade";

@Component({
    selector: 'combo-atividade',
    templateUrl: './combo-atividade.component.html',
    styleUrls: ['./combo-atividade.component.css'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm},
        {provide: ControlContainer, useExisting: forwardRef(() => NgModelGroup)}],
})
export class ComboAtividadeComponent implements OnInit {

    @ViewChild('comboAtividade', {static: false}) comboAtividade;

    @Input() showDisplayId;
    @Input() obrigatorio;
    @Input() selecionado;
    @Input() desabilitado;

    @Output() valorChange = new EventEmitter();

    dados = [];
    data: any = {};

    area: string;
    menu: string;

    constructor(private atividadeService: AtividadeService, 
        private router: Router, private activatedRoute: ActivatedRoute) {
    }

    ngOnInit(): void {
        this.data = Date.now();
        this.area = this.getArea();
        setTimeout(() => {
            this.atividadeService.getAllCombo().subscribe((atividades: Atividade[]) => {
                atividades = atividades.filter(o => !o.idTurma && o.area == this.area);
                this.dados = atividades;
                this.preencherCombo();
            });
        }, 0);
    }

    getMenu(): string {
        const primeiroSegmento = this.router.url.split('/')[1];
        return primeiroSegmento.startsWith('menu') ? primeiroSegmento : undefined;
    }

    private getArea(): string {
        this.menu = this.getMenu();
        return this.menu && this.menu == "menu-sap" ? 'S' : (this.menu && this.menu == "menu-pedagogico" ? 'P' : null);
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.preencherCombo();
    }

    private preencherCombo() {
        if (this.selecionado && this.selecionado.id && this.dados.length) {
            this.selecionado = _.find(this.dados, {id: this.selecionado.id});
        }
    }

    onValorChange(registro: any) {
        this.valorChange.emit(registro);
        this.preencherCombo();
    }


}
